import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { Router } from '@angular/router';
import { EventListStore } from '../../service/event-list.store';
import { EventSearchParameters } from '../../models/event-search-params';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { EventSearchSortType } from '../../models/dashboard/event-search-sort-type-enum';
import { EventSort } from '../../models/event-sort';
import { EventSearchFilter } from '../../models/event-filter';
import { PredefinedSearchService } from '../../service/predefined-search.service';
import { MultiAgencyService } from 'app/shared/multi-agency/multi-agency.service';
import { MultiAgency } from 'app/shared/models/multi-agency';
import { Subscription } from 'rxjs/Subscription';
import { OnDestroy } from '@angular/core';

@Component({
  selector: 'pioneer-recent-events-card',
  templateUrl: './event-list-card.component.html'
})
export class EventListCardComponent implements OnInit, OnDestroy {
  private static MAX_EVENTS: GLshort = 5;
  private data: Observable<List<OnyxSummaryEvent>>;
  private eventSearchRecentlyParameters: EventSearchParameters;

  private readonly defaultClasses = 'card collapse show';
  @HostBinding('attr.data-se-id') dataSeId = 'recentEventsCard_';
  @HostBinding('class') classes = this.defaultClasses;
  @HostBinding('id') id = '';

  agencySubscription$: Subscription = new Subscription();

  @Input('eventSearchSortType')
  public eventSearchSortType: EventSearchSortType;

  defaultAgency$: Observable<MultiAgency> = this.multiAgencyService.defaultAgency$;

  constructor(private eventListStore: EventListStore,
              private router: Router,
              private predefinedSearchService: PredefinedSearchService,
              private multiAgencyService: MultiAgencyService) {
  }

  ngOnInit() {
    let sorts: Array<EventSort> = new Array<EventSort>();
    let filters:  Array<EventSearchFilter> = new Array<EventSearchFilter>();
    let sort: EventSort;
    let filter: EventSearchFilter;
    this.dataSeId += this.eventSearchSortType;
    switch (this.eventSearchSortType) {
      case EventSearchSortType.MODIFIED:
        this.id = 'card-6';
        sort = new EventSort({
          sortField: 'modifiedDate',
          sortDirection: 'DESC'
        });
       sorts.push(sort);
       break;
      case EventSearchSortType.CREATED:
        this.id = 'card-7';
        sort = new EventSort({
          sortField: 'createdDate',
          sortDirection: 'DESC'
        });
        sorts.push(sort);
        break;
      case EventSearchSortType.COMPLETED:
        this.id = 'card-8';
        filter = new EventSearchFilter({
          filterField: 'eventStatusCompleted',
          filterValue: 'true'
        });
        sort = new EventSort({
          sortField: 'modifiedDate',
          sortDirection: 'DESC'
        });
        sorts.push(sort);
        filters.push(filter);
        break;
    }

    this.eventSearchRecentlyParameters =  new EventSearchParameters({
      maxEvents: EventListCardComponent.MAX_EVENTS,
       filters: filters,
      sorts: sorts
    });

    this.agencySubscription$ = this.defaultAgency$.subscribe(() => {
      this.data = this.eventListStore.loadRecentlyEvents(this.eventSearchRecentlyParameters);
    });
  }

  get events(): Observable<List<OnyxSummaryEvent>> {
    return this.data;
  }

  // TODO hide the MODIFIED and CREATED footer links for now
  isFooterLinkActive(eventType: EventSearchSortType): boolean {
    return eventType === EventSearchSortType.COMPLETED;
  }

  onSelectFooter(eventType: EventSearchSortType): void {
    switch (this.eventSearchSortType) {
      case EventSearchSortType.MODIFIED:
        // TODO
        break;
      case EventSearchSortType.CREATED:
        // TODO
        break;
      case EventSearchSortType.COMPLETED:
        this.predefinedSearchService.allCompleted();
        break;
    }
  }

  ngOnDestroy() {
    this.agencySubscription$.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/dashboard/recent-events-card/event-list-card.component.ts